import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { CampaignDetailTab } from './components/campaignDetailTab';
import { OverviewTab } from './components/overviewTab';
import { RecipientHistoryTab } from './components/recipientHistoryTab';
import { StatusDashboardHeader } from './components/statusDashboardHeader';
import { useStatusDashboardStyles } from './components/statusDashboardStyles';
import { StatusDashboardBreadcrumbs } from './components/statusDashboardBreadcrumbs';
import { useStatusDashboardStore } from './hooks/useStatusDashboardStore';

export const StatusDashboard = observer(() => {
  const classes = useStatusDashboardStyles();
  const { statusDashboardStore } = useStatusDashboardStore();

  useEffect(() => {
    statusDashboardStore.loadOverview();
    statusDashboardStore.loadOriginators();
    return () => statusDashboardStore.reset();
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <StatusDashboardHeader />
        <StatusDashboardBreadcrumbs />
        {statusDashboardStore.view === 'overview' && <OverviewTab />}
        {statusDashboardStore.view === 'campaign' && <CampaignDetailTab />}
        {statusDashboardStore.view === 'recipient' && <RecipientHistoryTab />}
      </div>
    </div>
  );
});
